/**
 * @generated SignedSource<<dfddefdae384084dbca7eadfefbfb033>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type flag_issueViewRedaction_RedactionFlag$data = {
  readonly lastRedactionTime: AGG$DateTime | null | undefined;
  readonly " $fragmentType": "flag_issueViewRedaction_RedactionFlag";
};
export type flag_issueViewRedaction_RedactionFlag$key = {
  readonly " $data"?: flag_issueViewRedaction_RedactionFlag$data;
  readonly " $fragmentSpreads": FragmentRefs<"flag_issueViewRedaction_RedactionFlag">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "flag_issueViewRedaction_RedactionFlag",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastRedactionTime"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "600b9b0116e7e1b66ab1f14bc11a5f02";

export default node;
